/* eslint-disable no-console */
import C from "../constants/constants";

const LOG = true;
const WARN = true;
const ERROR = true;

/**
 * Logs a message to the console.
 * @param message - The log message.
 * @param data - Additional data to log.
 */
const log = (message: string, data: any) => {
  if (C.ENVIRONMENT !== "production" && LOG) {
    console.log("[LOG]", `\n${message}`, data || "");
  }
};

/**
 * Logs a warning message to the console.
 * @param  message - The warning message.
 * @param data - Additional data to log.
 */
const warn = (message: string, data: any) => {
  if (C.ENVIRONMENT !== "production" && WARN) {
    console.warn(`[WARNING] ${message}`, data || "");
  }
};

/**
 * Logs an error message to the console.
 * @param message - The error message.
 * @param data - Additional data to log.
 */
const error = (message: string, data: any) => {
  if (C.ENVIRONMENT !== "production" && ERROR) {
    console.error(`[ERROR] ${message}`, data || "");
  }
};

export { error, log, warn };
